import { useCallback, useState } from 'react'
import type { ReserveChildMenuInput } from '~/lib/graphql/graphql'
import type { ChildMenuId } from '~/lib/graphql/scalars'
import { createOptions } from '../childMenu/useChangeCount'
import type { ReserveInputChildMenu } from '../store/stateMachine/state'

export function useMenuCard(
  menu: ReserveInputChildMenu,
  childCount: number,
  selected: ReserveChildMenuInput[]
) {
  const [opened, setOpened] = useState(false)
  const toggle = useCallback(() => {
    setOpened((v) => !v)
  }, [setOpened])
  const options = createChildMenuOptions(menu, childCount)
  const value = createChildMenuValue(menu, selected)
  return { opened, toggle, options, value }
}

function createChildMenuOptions(menu: ReserveInputChildMenu, childCount: number) {
  // お子様メニューの最大注文数は、メニュー自体の最大注文数と来店するお子様人数のうち少ない値
  const length =
    menu.maxOrderPerReservation === null
      ? childCount + 1
      : Math.min(childCount, menu.maxOrderPerReservation) + 1
  return createOptions(length, '点')
}
if (import.meta.vitest) {
  const { expect, it } = import.meta.vitest
  it('createChildMenuOptions', () => {
    let menu = {
      childMenuId: '1' as ChildMenuId,
      name: 'お子様メニュー',
      maxOrderPerReservation: 2,
    } as ReserveInputChildMenu
    expect(createChildMenuOptions(menu, 1)).toEqual(['0点', '1点'])
    expect(createChildMenuOptions(menu, 2)).toEqual(['0点', '1点', '2点'])
    expect(createChildMenuOptions(menu, 3)).toEqual(['0点', '1点', '2点'])
    menu.maxOrderPerReservation = null
    expect(createChildMenuOptions(menu, 3)).toEqual(['0点', '1点', '2点', '3点'])
  })
}

function createChildMenuValue(menu: ReserveInputChildMenu, selected: ReserveChildMenuInput[]) {
  const result = selected.find((v) => v.childMenuId === menu.childMenuId)?.count ?? 0
  return `${result}点`
}
if (import.meta.vitest) {
  const { expect, it } = import.meta.vitest
  it('createChildMenuValue', () => {
    const menu = {
      childMenuId: '1' as ChildMenuId,
      name: 'お子様メニュー',
    } as ReserveInputChildMenu
    let selected = [
      {
        childMenuId: '1',
        count: 2,
      },
    ] as ReserveChildMenuInput[]
    expect(createChildMenuValue(menu, selected)).toBe('2点')
    selected[0].childMenuId = '2' as ChildMenuId
    expect(createChildMenuValue(menu, selected)).toBe('0点')
  })
}
